import React from 'react';
import { useMediaQuery } from 'react-responsive';
import WebHostingContent from './WebHostingContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <WebHostingContent history={history} />
  </Mobile>
);

export default MobileResponsive;
